import React, {memo} from 'react';
import LeafletContainer from "@ui/leafletCustom/leafletContainer/LeafletContainer";
import {sxMap} from './sx'
import PointsMapMutateSingleVoyage from "@containers/singleVoyage/mutateVoyage/points/map/PointsMapMutateSingleVoyage";
import PositionsMapMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/position/PositionsMapMutateSingleVoyage";

import {MapFeatures} from "@ui/leafletCustom/types";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import {useResizeMapByChangeDeps} from "@ui/leafletCustom/hooks/useResizeMapByChangeDeps";
import {useMapFeaturesContext} from "@ui/leafletCustom/context/mapContext/hooks/useMapFeaturesContext";

const MAP_SIZE = {
    width: '100%',
    height: '100%'
}


interface IProps {
    initialCenter?: [lat: number, lng: number]
}

const MapMutateSingleVoyage = memo(({initialCenter}: IProps) => {

    const {
        setMapFeatures,
        mapFeatures
    } = useMapFeaturesContext()

    const {
        miniModeRootSidebar,
        miniModeSecondarySidebar,
        modeSecondarySidebar,
    } = useViewContextMutateSingleVoyage()

    useResizeMapByChangeDeps({
        dependency: [miniModeRootSidebar,
            miniModeSecondarySidebar,
            modeSecondarySidebar,
        ],
        mapFeatures,
    })

    return (
        <LeafletContainer
            center={initialCenter}
            size={MAP_SIZE}
            sx={sxMap}
            hasFullScreen={false}
            mapFeaturesRef={(mapFeatures: MapFeatures) => {
                setMapFeatures(mapFeatures)
            }}
        >

            <PointsMapMutateSingleVoyage/>

            <PositionsMapMutateSingleVoyage/>

        </LeafletContainer>
    );
});

export default MapMutateSingleVoyage;